"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.string.pad-start");
var _shopList = require("@/api/shop/shopList");
var _wechatEvaluate = require("@/api/evaluate/wechatEvaluate");
var _dishEvaluate = require("@/api/evaluate/dishEvaluate");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'shopAnalysis',
  data: function data() {
    // 设置默认日期范围为近一个月
    var endDate = new Date();
    var startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1);
    var formatDate = function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
      storeList: [],
      tableLoading: true,
      // 搜索表单数据
      searchForm: {
        shopId: '',
        startDate: formatDate(startDate) + ' 00:00:00',
        endDate: formatDate(endDate) + ' 23:59:59'
      },
      // 表格数据
      tableData: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created: function created() {
    this.getShops();
    this.handleSearch();
  },
  methods: {
    // 格式化评分（保留1位小数）
    formatScore: function formatScore(score) {
      if (score === null || score === undefined) return '0';
      return Number(score).toFixed(1);
    },
    // 格式化百分比（解决浮点数精度问题）
    formatPercent: function formatPercent(value) {
      if (value === null || value === undefined) return '0%';
      return (Number(value) * 100).toFixed(2) + '%';
    },
    // 格式化综合评分（el-table-column formatter）
    formatS5: function formatS5(row) {
      if (row.s5 === null || row.s5 === undefined) return '0.0';
      return Number(row.s5).toString();
    },
    // 获取门店列表
    getShops: function getShops() {
      var _this = this;
      (0, _shopList.getStoreData)().then(function (res) {
        if (res && res.records) {
          _this.storeList = res.records;
        }
      }).catch(function (err) {
        console.error('获取门店列表失败:', err);
      });
    },
    //时间转换
    formatDate: function formatDate(date) {
      var formatB = function formatB(t) {
        return new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).format(new Date(+t)).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
      };
      return formatB(date);
    },
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      this.currentPage = 1;
      this.loadData();
    },
    // 导出方法
    handleExport: function handleExport() {
      var _this2 = this;
      this.$message.success('开始下载消息数据');
      // 这里可以调用API下载数据
      (0, _dishEvaluate.downloadShopEvaluationList)(this.searchForm).then(function (res) {
        _this2.$message.success('导出成功，请到导出日志下载');
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this3 = this;
      this.tableLoading = true;
      console.log('加载门店分析数据 - 页码:', this.currentPage, '每页:', this.pageSize);
      var params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        page: this.currentPage,
        limit: this.pageSize
      });
      (0, _dishEvaluate.getShopEvaluateList)(params).then(function (res) {
        console.log('门店分析数据:', res);
        // 格式化评分值（保留1位小数，使用数字类型）
        var formatToFixed1 = function formatToFixed1(val) {
          return val !== null && val !== undefined ? Math.round(Number(val) * 10) / 10 : 0;
        };
        _this3.tableData = (res.records || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            s1: formatToFixed1(item.s1),
            s2: formatToFixed1(item.s2),
            s3: formatToFixed1(item.s3),
            s4: formatToFixed1(item.s4),
            s5: formatToFixed1(item.s5)
          });
        });
        _this3.total = res.total || 0;
        _this3.tableLoading = false;
      }).catch(function (err) {
        console.error('加载失败:', err);
        _this3.tableLoading = false;
        _this3.$message.error('加载数据失败');
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};